import React, { Component } from 'react';
import Autosuggest from 'react-autosuggest';
import { VariableSizeList as List } from 'react-window';
import './CompanyAutoComplete.css';
import WarningModal from './WarningModal';

class CompanyAutocomplete extends Component {
  constructor(props) {
    super(props);
    const searchTerm = props.searchTerm || '';
    this.state = {
      searchTerm,
      suggestions: this.filterCompanies(searchTerm),
      showWarning: false,
      warningHoldData: null,
      isDropdownOpen: false,
      itemHeights: {},
    };
    this.listRef = React.createRef();
  }

  componentDidUpdate(prevProps) {
    if (this.props.searchTerm !== prevProps.searchTerm) {
      this.setState({ searchTerm: this.props.searchTerm || '' });
    }

    if (this.props.clearSearch !== prevProps.clearSearch) {
      this.setState({
        showWarning: true,
        warningHoldData: { ev: '', data: { suggestion: null, suggestionValue: null } },
        searchTerm: this.props.searchTerm,
      });
    }
  }

  filterCompanies = (value) => {
    const inputValue =value && value.trim().toLowerCase();
    const { companies } = this.props;
    const filteredSuggestions = companies &&  companies?.filter(company =>
      company?.name ? company?.name?.toLowerCase().includes(inputValue) : company?.email?.toLowerCase().includes(inputValue)
    );

    this.setState({ isDropdownOpen: filteredSuggestions?.length > 0 });

    return [{ title: 'Companies', suggestions: filteredSuggestions || [] }];
  };

  getCompanyValue = (company) => (company?.name || company?.email || '');

  getItemSize = (index) => {
    const company = this.state.suggestions[0]?.suggestions[index];
    if (!company) return 40;

    const textLength = (company.name || company.email).length;
    const lineCount = Math.ceil(textLength / 25);
    return Math.max(40, lineCount * 30);
  };

  renderSuggestion = ({ index, style }) => {
    const company = this.state.suggestions[0]?.suggestions[index];
    return (
      <div
        style={{
          ...style,
          padding: '8px',
          borderBottom: '1px solid #ddd',
          backgroundColor: '#fff',
          cursor: 'pointer',
          transition: 'background 0.2s ease-in-out',
          borderTop: '1px solid darkgray',
          whiteSpace: 'normal',
          wordWrap: 'break-word',
          display: 'flex',
          alignItems: 'center',
        }}
        onMouseEnter={(e) => (e.target.style.backgroundColor = '#e9ecef')}
        onMouseLeave={(e) => (e.target.style.backgroundColor = '#fff')}
        onMouseDown={() => this.onCompanySelected(null, { suggestion: company, suggestionValue: this.getCompanyValue(company) })}
      >
        {company.name || company.email}
      </div>
    );
  };

  onChange = (event, { newValue }) => {
    if (newValue === '') {
      this.props.onChange({ name: 'company', value: null, suggestion: null });
    } else if (this.props.onInputChange) {
      this.props.onInputChange(newValue);
    }
    this.setState({
      searchTerm: newValue,
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.filterCompanies(value),
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
      isDropdownOpen: false,
    });
  };

  onCompanySelected = (ev, { suggestion, suggestionValue }, action, success) => {
    const { showWarning } = this.props;
    if (success || !showWarning) {
      const evObj = { name: 'company', value: suggestionValue, suggestion, action };
      this.props.onChange(evObj);
      this.setState({ searchTerm: suggestionValue, isDropdownOpen: false }); // ✅ Close dropdown
    } else {
      this.setState({
        showWarning: true,
        warningHoldData: { ev, data: { suggestion, suggestionValue } },
        searchTerm: this.props.searchTerm,
      });
    }
  };

  onKeyPress = e => {
    if (!e.currentTarget.value) return;
    if (e.key === 'Enter') {
      const { companies, userAutocomplete } = this.props;
      let suggestion = !userAutocomplete
        ? companies.filter(item => item?.name === e.currentTarget.value)
        : companies.filter(item => item?.email === e.currentTarget.value);
      this.props.onChange({
        name: 'company',
        value: e.currentTarget.value,
        suggestion: suggestion[0] ? { ...suggestion[0] } : null,
      });
      this.setState({ isDropdownOpen: false });
    }
  };

  onWarningClose = () => {
    this.setState({
      showWarning: false,
      warningHoldData: null,
    });
  };

  onWarningActionChange = action => {
    const { warningHoldData } = this.state;
    this.onCompanySelected(warningHoldData.env, warningHoldData.data, action, true);
    this.onWarningClose();
  };

  renderSectionTitle = section => {
    return <strong>{section?.title}</strong>;
  };

  getSectionSuggestions = section => {
    return section?.suggestions || [];
  };

  render() {
    const { searchTerm, suggestions, isDropdownOpen } = this.state;
    const { subText, warningText, showWarning, className } = this.props;
    // Autosuggest will pass through all these props to the input.
    const inputProps = {
      id: 'company-autocomplete-input',
      placeholder: this.props.placeholder || 'Search Company...',
      disabled: this.props.isDisabled || this.props.editStatus,
      value: searchTerm,
      onChange: this.onChange,
      onKeyPress: this.onKeyPress,
      name: 'company',
      requires: 'true',
      type: 'text',
      className: 'form-control',
    };

    // Finally, render it!
    return (
      <div className={className || 'autocomplete-container'}>
        <Autosuggest
          suggestions={suggestions ? suggestions : []}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={this.getCompanyValue}
          multiSection
          renderSectionTitle={this.renderSectionTitle}
          getSectionSuggestions={this.getSectionSuggestions}
          inputProps={inputProps}
          shouldRenderSuggestions={() => true}
          onSuggestionSelected={this.onCompanySelected}
          renderSuggestionsContainer={({ containerProps }) => (
            <div
              {...containerProps}
              style={{
                maxHeight: isDropdownOpen ? 200 : 0,
                border: isDropdownOpen ? '1px solid #ced4da' : 'none',
                boxShadow: isDropdownOpen ? '0px 4px 6px rgba(0,0,0,0.1)' : 'none',
              }}
              className="virtualization-container"
            >
              {isDropdownOpen && suggestions.length > 0 && suggestions[0]?.suggestions?.length > 0 && (
                <List
                  ref={this.listRef}
                  height={200}
                  itemCount={suggestions[0]?.suggestions?.length  || 0}
                  itemSize={this.getItemSize}
                  width="100%"
                >
                  {this.renderSuggestion}
                </List>
              )}
            </div>
          )}
          id="company-autocomplete"
        />

        {subText && <p className="sub-text">{subText}</p>}
        {showWarning && (
          <WarningModal
            onCancel={this.onWarningClose}
            onCustomAction={() => this.onWarningActionChange('transfer')}
            onConfirm={() => this.onWarningActionChange('erase')}
            isOpen={this.state.showWarning}
            onSelectorChange={this.onSelectorChange}
            body={warningText}
            noButtonText="Cancel"
            customButtonText="Transfer"
            yesButtonText="Erase"
          />
        )}
      </div>
    );
  }
}

export default CompanyAutocomplete;

